
                                                                                                                                                                                                                                                                                                                                                                                                            

                                                                                                                                                                                                                                                                                                                                                                            import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

let domain = window.location.hostname;

  let language = localStorage.getItem('language');
  if (!language) {
    language = 'en';
  }
  localStorage.setItem('language', language);


localStorage.setItem('domain', domain);
console.log = (...args) => { };

  platformBrowserDynamic()
    .bootstrapModule(AppModule, { preserveWhitespaces: true })
    .catch(err => console.log(err));
